const dateNow = new Date(Date.now())
const yearNow = dateNow.getFullYear();
const nextYear = Number(yearNow) + 1;
const monthNow = dateNow.getMonth() + 1;
const dayNow = dateNow.getDate();

const formattedDateNow = `${monthNow}/${dayNow}/${yearNow}`;
const formattedDateNextYear = `${monthNow}/${dayNow}/${nextYear}`;

let netRateData = [
    {
            field: "ASCS_Business_Auto_Territory",
            value: "",
            xmlVariable: "{{ASCS_Business_Auto_Territory}}",
            uiVariable: "questions.primaryIsoTerritory"
    },
    {
            field: "ASCS_Date_Prepared",
            value: formattedDateNow,
            xmlVariable: "{{ASCS_Date_Prepared}}",
            uiVariable: ""
    },
    {
            field: "ASCS_Effective_Date",
            value: formattedDateNow,
            xmlVariable: "{{ASCS_Effective_Date}}",
            uiVariable: ""
    },
    {
            field: "ASCS_Expiration_Date",
            value: formattedDateNextYear,
            xmlVariable: "{{ASCS_Expiration_Date}}",
            uiVariable: ""
    },
    {
            field: "ASCS_Farthest_Zone",
            value: "",
            xmlVariable: "{{ASCS_Farthest_Zone}}",
            uiVariable: "questions.farthestZone"
    },
    {
            field: "ASCS_Garage_Zone",
            value: "",
            xmlVariable: "{{ASCS_Garage_Zone}}",
            uiVariable: "questions.garageZone"
    },
    {
            field: "ASCS_Insured_Address",
            value: "",
            xmlVariable: "{{ASCS_Insured_Address}}",
            uiVariable: "insured.company.address.street1"
    },
    {
            field: "ASCS_Insured_City",
            value: "",
            xmlVariable: "{{ASCS_Insured_City}}",
            uiVariable: "insured.company.address.city"
    },
    {
            field: "ASCS_Insured_Name",
            value: "",
            xmlVariable: "{{ASCS_Insured_Name}}",
            uiVariable: "insured.company.name"
    },
    {
            field: "ASCS_Insured_State",
            value: "",
            xmlVariable: "{{ASCS_Insured_State}}",
            uiVariable: "insured.company.address.state"
    },
    {
            field: "ASCS_Insured_Zip",
            value: "",
            xmlVariable: "{{ASCS_Insured_Zip}}",
            uiVariable: "insured.company.address.zip"
    },
    {
            field: "ASCS_Operating_Radius",
            value: "",
            xmlVariable: "{{ASCS_Operating_Radius}}",
            uiVariable: ""
    },
    {
            field: "ASCS_Quote_Identifier",
            value: "",
            xmlVariable: "{{ASCS_Quote_Identifier}}",
            uiVariable: ""
    },
    {
            field: "ASCS_Rating_Basis_Date",
            value: formattedDateNow,
            xmlVariable: "{{ASCS_Rating_Basis_Date}}",
            uiVariable: ""
    },
    {
            field: "ASCS_Radius_Miles",
            value: "",
            xmlVariable: "{{ASCS_Radius_Miles}}",
            uiVariable: "questions."
    },
    {
            field: "ASCS_Reg_Effective_Date",
            value: "1/1/2020",
            xmlVariable: "{{ASCS_Reg_Effective_Date}}",
            uiVariable: ""
    },
    {
            field: "ASCS_Reg_Expiratin_Date",
            value: "12/31/2030",
            xmlVariable: "{{ASCS_Reg_Expiration_Date}}",
            uiVariable: ""
    },
    {
            field: "ASCS_Transaction_Date",
            value: formattedDateNow,
            xmlVariable: "{{ASCS_Transaction_Date}}",
            uiVariable: ""
    },
    {
            field: "ASCS_Unit_Number",
            value: "1",
            xmlVariable: "{{ASCS_Unit_Number}}",
            uiVariable: ""
    },
    {
            field: "ASCS_Power_Units",
            value: 0,
            xmlVariable: "{{ASCS_Power_Units}}",
            uiVariable: "insured.company.numberOfVehicles"
    }
];

module.exports = netRateData;